import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';

@Component({
  selector: 'readability-free',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    HttpClientModule],
  templateUrl: './readability-free.component.html',
  styleUrl: './readability-free.component.css'
})
export class ReadabilityFreeComponent {
  public text_line?: string;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  isLessThan100Words: boolean = true;
  
  verifyLoaderActive2: boolean;

  public readability={
    flesch_reading:0,
    flesch_kincaid:0,
    gunning_fog:0,
  }
  project_data: any;

  private proyectoSub;

  constructor(
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService
  ) { }

  getBoxLineColorReading(value: number): string {
    if (value >= 0 && value <= 60) {
      return 'box-line-red';
    } else if (value > 60 && value <= 80) {
      return 'box-line-yellow';
    } else if (value > 80) {
      return 'box-line-green';
      
    }
    return 'box-line';
  }

  getBoxLineColorKincaid(value: number): string {
    if (value >= 0 && value <= 6) {
      return 'box-line-green';
    } else if (value > 6 && value <= 13) {
      return 'box-line-yellow';
    } else if (value > 13) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getBoxLineColorFog(value: number): string {
    if (value >= 0 && value <= 6) {
      return 'box-line-green';
    } else if (value > 6 && value <= 10) {
      return 'box-line-yellow';
    } else if (value > 10) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getTextLineReading(value: number): string {
    if (value >= 0 && value < 30) {
      return 'Very Low Readability: University Graduate Reading Level';
    } else if (value == 30 ) {
      return 'Very Low Readability: University Graduate Reading Level';
    } else if (value > 30 && value <= 50) {
      return 'Low Readability: University Student Reading Level';
    }else if (value > 50 && value <= 60) {
      return 'Low Readability: 10th to 12th Grade Reading Level';
    }else if (value > 60 && value <= 70) {
      return 'Moderate Readability: 8th and 9th Grade Reading Level';
    }else if (value > 70 && value <= 80) {
      return 'Moderate Readability: 7th Grade Reading Level';
    }else if (value > 80 && value <= 90) {
      return 'High Readability: 6th Grade Reading Level';
    }else if (value > 90 && value <= 100) {
      return 'High Readability: 5th Grade Reading Level';
    }else if (value > 100) {
      return 'High Readability';
    }
    
    return '';
  }

  getTextLineKincaid(value: number): string {
    if (value >= 0 && value <= 1) {
      return 'High Readability: 1st Grade Reading Level';
    } else if (value > 1 && value <= 2) {
      return 'High Readability: 1st Grade Reading Level';
    } else if (value > 2 && value <= 3) {
      return 'High Readability: 2nd Grade Reading Level';
    } else if (value > 3 && value <= 4) {
      return 'High Readability: 3rd Grade Reading Level';
    } else if (value > 4 && value <= 5) {
      return 'High Readability: 4th Grade Reading Level';
    } else if (value > 5 && value <= 6) {
      return 'High Readability: 5th Grade Reading Level';
    } else if (value > 6 && value <= 7) {
      return 'Moderate Readability: 6th Grade Reading Level';
    } else if (value > 7 && value <= 8) {
      return 'Moderate Readability: 7th Grade Reading Level';
    } else if (value > 8 && value <= 9) {
      return 'Moderate Readability: 8th Grade Reading Level';
    } else if (value > 9 && value <= 10) {
      return 'Moderate Readability: 9th Grade Reading Level';
    } else if (value > 10 && value <= 11) {
      return 'Moderate Readability: 10th Grade Reading Level';
    } else if (value > 11 && value <= 12) {
      return 'Moderate Readability: 11th Grade Reading Level';
    } else if (value > 12 && value <= 13) {
      return 'Moderate Readability: 12th Grade Reading Level';
    } else if (value > 13 && value <= 16) {
      return 'Low Readability: University Student Reading Level';
    } else if (value > 16 && value <= 18) {
      return 'Very Low Readability: University Graduate Reading Level';
    } else if (value > 18) {
      return 'Very Low Readability: University Graduate Reading Level';
    }
    
    return '';
  }
  
  getTextLineFog(value: number): string {
    if (value >= 0 && value <= 1) {
      return 'High Readability: 1st Grade Reading Level';
    } else if (value > 1 && value <= 2) {
      return 'High Readability: 1st Grade Reading Level';
    } else if (value > 2 && value <= 3) {
      return 'High Readability: 2nd Grade Reading Level';
    } else if (value > 3 && value <= 4) {
      return 'High Readability: 3rd Grade Reading Level';
    } else if (value > 4 && value <= 5) {
      return 'High Readability: 4th Grade Reading Level';
    } else if (value > 5 && value <= 6) {
      return 'High Readability: 5th Grade Reading Level';
    } else if (value > 6 && value <= 7) {
      return 'Moderate Readability: 6th Grade Reading Level';
    } else if (value > 7 && value <= 8) {
      return 'Moderate Readability: 7th Grade Reading Level';
    } else if (value > 8 && value <= 9) {
      return 'Moderate Readability: 8th Grade Reading Level';
    } else if (value > 9 && value <= 10) {
      return 'Moderate Readability: 9th Grade Reading Level';
    } else if (value > 10 && value <= 11) {
      return 'Low Readability: 10th Grade Reading Level';
    } else if (value > 11 && value <= 12) {
      return 'Low Readability: 11th Grade Reading Level';
    } else if (value > 12 && value <= 13) {
      return 'Low Readability: 12th Grade Reading Level';
    } else if (value > 13 && value <= 14) {
      return 'Low Readability: First-year University Student Reading Level';
    } else if (value > 14 && value <= 15) {
      return 'Low Readability: Second-year University Student Reading Level';
    } else if (value > 15 && value <= 16) {
      return 'Low Readability: Third-year University Student Reading Level';
    } else if (value > 16 && value <= 17) {
      return 'Low Readability: Fourth-year University Student Reading Level';
    } else if (value > 17 && value <= 20) {
      return 'Very Low Readability: University Graduate Reading Level';
    } else if (value > 20) {
      return 'Very Low Readability: University Graduate Reading Level';
    }
    
    return '';
  }
  
  

  ngOnInit(): void {
    localStorage.setItem("actual","readabilityF")
    this.initSubscribe();
    if(sessionStorage.getItem("id_project")){
     this.initReadability();
     }
    this.proyectoService.wordCount$.subscribe(isLessThan100 => {
      if(sessionStorage.getItem("text_UID")){
        this.isLessThan100Words = isLessThan100;
      }else{
        this.isLessThan100Words = false;
      }
    });
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });

                this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });
         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });

    this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

     setInterval(() => {
       let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "readabilityF" && sessionStorage.getItem("readability") !== "-" && !this.loaderActive && sessionStorage.getItem("id_project") && !this.verifyLoaderActive2){
       this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.initReadability()
      }
      }, 20 * 1000); // 30 segundos
  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
    //Subscribimos al servicio para escuchar los datos
   this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
       if(!firstProject){
          this.loaderActive = false;
          if(sessionStorage.getItem("text_UID")){
            if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
          }else{
            this.loaderActive2 = false;
          }
        }
        if(firstProject){
          this.loaderActive = false;
          if(sessionStorage.getItem("text_UID")){
            this.loaderActiveFirstProject = true;
          }else{
            this.loaderActiveFirstProject = false;
          }
        }
      console.log("Update de data --Reporta: Summary--")
      this.project_data = proyecto;
      if(sessionStorage.getItem("id_project")){
          this.initReadability();
        }
    });
  }
  }

  status: any;
  async initReadability(){
    let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "readabilityF"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("readability");
  
      if (memoryStorage) {
        if(memoryStorage !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.readability = JSON.parse(memoryStorage);
        } catch (error) {
          console.log("Error en la petición de datos")
          console.log(error)
          sessionStorage.removeItem('readability');
        }finally{
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
        }
      }
      }
      else{
        sessionStorage.setItem("readability", "-");
        //Tenemos que esperar unos milisegundos en lo que el servicio actualiza la info
        await new Promise(resolve => setTimeout(resolve, 10));
        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta = await this.fachada.getReadabilityOfProject(this.http,textUID,"");
          this.readability = respuesta
          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("readability", JSON.stringify(this.readability));
          this.status = 200
        } catch (error) {
           if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (readability)");
            sessionStorage.removeItem('readability');
            this.status = 0

          }else{
            console.log("Error en la petición de datos")
          console.log(error)
          sessionStorage.removeItem('readability');
          }

          this.status = error?.status;
          
        }finally{
          if(this.status ===0){
            this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.proyectoService.updateloader(true);
            setTimeout(() => {
              this.initReadability();
            }, 100);
          }else{
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.proyectoService.updateloader(false);
            setTimeout(() => {
              this.initReadability();
            }, 100);
            }
          
        
        }
      }
       }else{
      console.log(`readability no es la pantalla actual así que bloqueamos peticiones`)
    }
   
  }
   
}
